import Text from '../components/main/Text';
import '../utils/GlobalStyles.css';
import './styles/NotFound.css';

interface BrandInfo {
  name?: string;
  logo?: string;
  claim?: string;
  primaryColor?: string;
}

function NotFound({ brand }: { brand?: BrandInfo } = {})
{
    return (
        <div
            className = 'centered not-found'
            style = {{ flexDirection: 'column', gap: '22px' }}
        >
            {brand?.logo && <img src={brand.logo} alt={brand.name || ''} style={{ maxHeight: 56 }} />}
            <Text
                text = 'OOOPS...'
                fontSize = {28}
                color = 'white'
                fontWeight = {700}
                letterSpacing = '0.35px'
            />

            <Text
                text = 'Unfortunately, the vCard you were looking for could not be found.'
                fontSize = {20}
                lineHeight = '28px'
                color = 'white'
                letterSpacing = '0.35px'
            />
            {brand?.name && <Text text={brand.name} fontSize={16} color='white' letterSpacing='0.35px' />}
        </div>
    )
}

export default NotFound;